import { ModelYhcKazaiDeliveryPeakSeasonRules } from '../../../fireModels/yhcDataTypes'
import { formatDateForMD } from './YhcEFDatetimeInputs/dateFormatter'
import { hasDeliverableItemCountsLimit } from './peakSeasonRuleUtils'

export const overDeliverableItemCountsMessage = (
  deliveryPeakSeasonRule: ModelYhcKazaiDeliveryPeakSeasonRules,
): string | null => {
  if (!hasDeliverableItemCountsLimit(deliveryPeakSeasonRule)) return null
  return `<span style="color: red;">${formatDateForMD(
    deliveryPeakSeasonRule.startDate,
  )} ～ ${formatDateForMD(
    deliveryPeakSeasonRule.endDate,
  )}</span>は引越シーズンのため配送可能な家財は<span style="color: red;">${
    deliveryPeakSeasonRule.deliverableItemCounts
  }点</span>までとなります。`
}
